import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';
import fonts from '../../../../utils/Fonts';

const ExerciseListElementFields = {
  group: ELEMENT_GROUPS.MEDIA,
  label: 'Exercise List',
  icon: 'DocumentIcon',
  description: 'Adds a list of exercises',
  properties: [
    'margin',
    'padding',
    {
      label: 'Add Set Action',
      name: 'actionAddExerciseSet',
      editor: 'dropdown',
      default: '',
      description: 'An action to run when a set is added to an exercise',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },

      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Delete Exercise Action',
      name: 'actionDeleteExercise',
      editor: 'dropdown',
      default: 'An action to run when the delete exercise button is clicked',
      description: 'An action to ',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },

      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Delete Set Action',
      name: 'actionDeleteExerciseSet',
      editor: 'dropdown',
      default: '',
      description: 'An action to run when a set is removed from an exercise',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },

      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Exercise Info Action',
      name: 'actionInfoExercise',
      editor: 'dropdown',
      default:
        'An action to run when the info icon is pressed next to an exercise',
      description: 'An action to ',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Edit Exercise Name Action',
      name: 'actionEditExerciseName',
      editor: 'dropdown',
      default: '',
      description:
        'An action to run the pencil icon is clicked next to an exercise name',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },

      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Exercise Title Color',
      name: 'exerciseTitleColor',
      editor: 'color',
      default: '',
      description: 'The color of the exercise name',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Exercise Title Font',
      name: 'exerciseTitleFont',
      editor: 'fontsize',
      default: 20,
      description: 'The font to use for the exercise for the title',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Exercise Title Font Family',
      name: 'exerciseTitleFontFamily',
      editor: 'dropdown',
      type: 'number',
      default: 14,
      options: [{ label: '<Not Set>', value: '' }, ...fonts],
      description: 'The font family of the exercise title in a filled slot',
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Exercise Data Binding Source',
      name: 'datasourceId',
      description: 'The data source to retrieve the list of exercises from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',

      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Exercise Sets Data Binding Source',
      name: 'datasourceIdSets',
      description:
        'The data source to retrieve the list of sets for an exercise, from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',

      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    }
  ]
};

export default ExerciseListElementFields;
